import _ from 'lodash'
import { dataStore } from './dataStore'
import { useParams } from 'react-router-dom'
import { useProjects } from '../hooks/useProjects'

export function useSiteCustomIds() {
  const { data: allProjects } = useProjects()
  const { projectId } = useParams() as { projectId: string }
  const sites = allProjects.find((project) => project._id === projectId)!.sites

  const statsExtraProjects = dataStore((state) => state.statsExtraProjects)
  const extraSites = statsExtraProjects?.map((project) => project.sites).flat() ?? []
  const sitesWithExtraSites = [...sites, ...extraSites]

  const [sitesWithCustomId, sitesWithoutCustomId] = _.partition(sitesWithExtraSites, (site) => site.customId)
  const uniqSites = _.uniqBy(sitesWithCustomId, (s) => s.customId!)
  const uniqSiteCustomIds = uniqSites.map((s) => s.customId!)
  const uniqSanosCustomIds = uniqSiteCustomIds.filter((customId) => customId.toLowerCase().includes('sanos'))

  return { uniqSiteCustomIds, uniqSanosCustomIds, uniqSites, sitesWithCustomId, sitesWithoutCustomId }
}
